define('open-dialog-links',['elements', 'dialogs'], function(elements, dialogs) {
	elements.register(function(elem) {
		elem.find('.open-dialog-button').click(function(e) {
			e.preventDefault();
			var dialog = dialogs.create($(this).data('dialog'));
			dialogs.showModal(dialog);
		});
	})
});

